import React, { useRef , useEffect} from "react";
import { ShieldCheck, TriangleAlert, WifiOff, ServerCrash, Lock, RefreshCw } from "lucide-react";
import { useAuth } from "../context/AuthContext";

function VerificationForm({ 
  code, 
  setCode, 
  handleSubmit, 
  isLoading, 
  isComplete,
  error,
  shake,
  onResend
}) {

    const { logout,restartSetPass } = useAuth();
  

    // Icono según tipo de error
  const getErrorIcon = () => {
    if (!error) return null;
    if (error.includes('conexión') || error.includes('internet')) return <WifiOff size={18} />;
    if (error.includes('servidor')) return <ServerCrash size={18} />;
    if (error.includes('bloqueada') || error.includes('intentos')) return <Lock size={18} />;
    if (error.includes('expirado') || error.includes('Sesión')) return <RefreshCw size={18} />;
    return <TriangleAlert size={18} />;
  };
  const inputRefs = useRef([]);

  useEffect(() => {
    // enfocar el primer input al montar
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);
  
  // Manejo de cambio de cada input
  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // mover focus al siguiente
    if (value && index < code.length - 1) {
      inputRefs.current[index + 1].focus();
    }

    // si todos los inputs están completos, hacer submit automático
    if (newCode.every((digit) => digit !== "")) {
      handleSubmit(newCode.join(""));
    }
  };

  // Manejo de retroceso con Backspace
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  // Manejo de pegar el código
  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text").slice(0, code.length);
    if (!/^\d+$/.test(paste)) return;
    const newCode = paste.split("");
    setCode([...newCode, ...Array(code.length - newCode.length).fill("")]);
  };

  return (
    <div className={`verification-form ${shake ? 'shake-animation' : ''}`}>
      
      <button 
        type="button"
        className="text-link back-button"
        onClick={() => {
          restartSetPass(false);
          logout();
        }}
        disabled={isLoading}
        style={{
          background: 'none',
          border: 'none',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          fontFamily: 'inherit',
          padding: 0,
          color: 'rgba(255, 255, 255, 0.6)',
          fontSize: '11px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          marginBottom: '24px',
          opacity: isLoading ? 0.5 : 1,
          transition: 'opacity 0.2s'
        }}
      >
        ← Volver al inicio de sesión
      </button>

      <div className="verify-header">
        <h1>Verificación</h1>
        <p>Ingresa el código de 6 dígitos enviado a tu correo</p>
      </div>

      {/* Mensaje de error */}
      {error && (
        <div className="verify-error">
          {getErrorIcon()}
          <span>{error}</span>
        </div>
      )}

      <div className="code-inputs">
        {code.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            className={digit ? "filled" : ""}
            disabled={isLoading}
          />
        ))}
      </div>

      <button
        className={`verify-btn ${isLoading ? "loading" : ""}`}
        onClick={() => handleSubmit(code.join(""))}
        disabled={!isComplete || isLoading}
      >
        {isLoading ? <span className="loader" /> : "Verificar código"}
      </button>

      <div className="verify-footer">
        <span>¿No recibiste el código?</span>
        <button
          className="resend-btn"
          onClick={onResend}
          disabled={isLoading}
        >
          Reenviar
        </button>
      </div>
    </div>
  );
}

export default VerificationForm;
